const HelperDomain = {
	
	trim: ( domain ) => {
		return domain?.trim().toLowerCase().replace(/[^a-z0-9._]/gi,'' );
	},
	
	valid: ( domain ) => {
		return HelperDomain.trim( domain ).replaceAll('.', '_' );
	}
}

export default HelperDomain
